import { createContext, useContext } from 'react';

export type ScrollRestorationType = {
  state: { [key: string]: string };
  saveScrollY: (scrollY: number) => void;
  getScrollY: (page: string) => number;
  scrollTo: (page: string) => void;
};

const ScrollRestorationContext = createContext<ScrollRestorationType>({
  state: {},
  saveScrollY: (scrollY: number) => null,
  getScrollY: (page: string) => 0,
  scrollTo: (page: string) => null,
});

export const useScrollRestorationContext = () => useContext(ScrollRestorationContext);

export default ScrollRestorationContext;
